import Login from '@/views/Login'
import Password from '@/views/Password'
import Home from '@/views/Home'
//import Test from '@/views/Test'

export default [
    { path: '/',                                                        name: 'login',                          component: Login,                           meta: { authRequired: false,    desc: '로그인'} },
    { path: '/password',                                                name: 'password',                       component: Password,                        meta: { authRequired: false,    desc: '패스워드변경'} },
    { path: '/home',                                                    name: 'home',                           component: Home,                            meta: { authRequired: true,		  desc: 'home' } },
]



// WEBPACK FOOTER //
// ./src/router/common/index.js